import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Slot } from './slot.model';

export function endAfterStartValidator(): ValidatorFn {
  return (control: AbstractControl<Slot>): ValidationErrors | null => {
    const value = control.value;
    const start = value.startTime;
    const end = value.endTime;
    if (!start && !end) return null;
    if (!start || !end) return { required: true };
    return toMinutes(end) > toMinutes(start) ? null : { endBeforeStart: true };
  };
}

function toMinutes(time: string): number {
  const [hh, mm] = time.split(':').map(Number);
  return hh * 60 + mm;
}
